import Icon from '../components/Icon.vue'

Icon.register({
  poop: {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M451.4 369.1C468.7 356 480 335.4 480 312 480 272.2 447.8 240 408 240H393.9C407.4 228.3 416 211.2 416 192 416 156.6 387.4 128 352 128H346.1C349.7 117.9 352 107.3 352 96 352 43 309 0 256 0 250.8 0 245.8 0.7 240.9 1.5 250.3 14.6 256 30.6 256 48 256 92.2 220.2 128 176 128H160C124.7 128 96 156.6 96 192 96 211.2 104.7 228.3 118.1 240H104C64.2 240 32 272.2 32 312 32 335.4 43.3 356 60.6 369.1 26.3 374.6 0 404.1 0 440 0 479.8 32.2 512 72 512H440C479.8 512 512 479.8 512 440 512 404.1 485.7 374.6 451.4 369.1z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/poop.js
// module id = skjP
// module chunks = 144